import React from 'react'
import { AllCardsType } from '../../data/all-cards'
import { randomNumberInRange } from '../../utils/functions'
import { useWidth } from '../../hooks/useWidth'

type PhotoCards10Props = {
    cards: AllCardsType[]
    mazo: string
    tapiz: string
}

/** Foto compartida para tiradas de 10 cartas (grilla 5x2 compacta y centrada). */
const PhotoCards10 = ({ cards, mazo, tapiz }: PhotoCards10Props) => {
    const width = useWidth()
    const translate = width >= 1280 ? 12 : 4

    return (
        <div className="relative mini:w-[80vw] mini:h-[52vw] xl:w-[65vw] xl:h-[44vw] after:bg-white-gradient after:absolute after:w-full after:h-full after:z-20 after:top-0 after-left-0 overflow-hidden">
            <div
                className="absolute inset-[-240px] bg-cover"
                style={{
                    transform: `rotate(${randomNumberInRange(-5, 5)}deg) translateY(${
                        randomNumberInRange(-40, 40) + 'px'
                    }) translateX(${randomNumberInRange(-40, 40) + 'px'})`,
                    backgroundImage: `url(/fondos/${tapiz}.jpg)`,
                }}
            ></div>
            <div className="relative flex items-center justify-center w-full h-full mini:py-10 xl:py-14">
                <div className="grid grid-cols-5 gap-x-2 gap-y-3 place-items-center w-fit">
                    {cards.map((card: AllCardsType, index: number) => (
                        <img
                            key={index}
                            src={require('../../assets/' + mazo + card.url + '/' + card.image)}
                            className={
                                card.url === 'mayores'
                                    ? 'w-[8vw] h-[14.85vw] mini:rounded-sm xl:rounded-[7px]'
                                    : 'bg-white w-[8vw] h-[14.85vw] mini:rounded-sm xl:rounded-[7px]'
                            }
                            style={{
                                transform:
                                    'rotate(' +
                                    `${
                                        card.position !== 'invertida'
                                            ? randomNumberInRange(-5, 5)
                                            : randomNumberInRange(175, 185)
                                    }` +
                                    'deg) translateY(' +
                                    randomNumberInRange(-translate, translate) +
                                    'px',
                            }}
                            alt=""
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PhotoCards10
